export class ProdutoCategoriaPreCadastroFormModel {
  constructor(public nomeCategoria: string = "", public categoriaId: string | null = null) {}
}
